export enum PhoneTypes {
  HOME = "HOME",
  WORK = "WORK",
  OTHER = "OTHER",
}
